import { ApiService } from './api';
import { ApiResponse } from '../types/auth';
import {
  RatingsListResponse,
  RatingsRequest,
  OrderRatingResponse
} from '../types/ratings';

export class RatingsService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async getRatings(request: RatingsRequest): Promise<ApiResponse<RatingsListResponse>> {
    try {
      const params = new URLSearchParams({
        page: request.page.toString(),
        pageSize: request.pageSize.toString(),
      });

      const response = await this.apiService.get<RatingsListResponse>(
        `/admin/ratings?${params.toString()}`
      );

      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to fetch ratings',
        success: false
      };
    }
  }

  async getOrderRating(orderId: number): Promise<ApiResponse<OrderRatingResponse>> {
    try {
      const response = await this.apiService.get<OrderRatingResponse>(
        `/admin/orders/${orderId}/rating`
      );

      return {
        data: response,
        success: true
      };
    } catch (error) {
      // 404 means no rating exists, which is not really an error
      if (error instanceof Error && error.message.includes('404')) {
        return {
          data: undefined,
          success: true
        };
      }

      return {
        error: error instanceof Error ? error.message : 'Failed to fetch order rating',
        success: false
      };
    }
  }

  async recalculateRatings(): Promise<ApiResponse<void>> {
    try {
      await this.apiService.get<void>('/admin/ratings/recalculate');

      return {
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to recalculate ratings',
        success: false
      };
    }
  }

  async deleteRating(orderId: number): Promise<ApiResponse<void>> {
    try {
      await this.apiService.delete<void>(`/admin/orders/${orderId}/rating`);

      return {
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to delete rating',
        success: false
      };
    }
  }
}

export const ratingsService = new RatingsService();
